module.exports = __webpack_public_path__ + "img/two.a8f85bd0.jpg";